export const countryGroups = ['us-ca', 'au', 'nz', 'uk-ie'] as const;
